import { useState } from 'react';

/**
 * useClipboard - copies text and briefly shows a "copied" state
 * @param {number} timeout - ms before reverting to idle (default 1800)
 */
export function useClipboard(timeout = 1800) {
  const [copiedId, setCopiedId] = useState(null);

  const copy = (id, text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), timeout);
    });
  };

  return { copiedId, copy };
}
